import { CASES } from './constants';

export const updateReadyProducts = (payload) => {
    return { type: CASES.UPDATE_READY_PRODUCTS, payload };
};


export const clearReadyProducts = () => {
    return { type: CASES.CLEAR_READY_PRODUCTS, payload: {} };
};
